<template>
  <div>
    <cv-toast-notification
      v-show="elementVisible"
      v-if="isVisible"
      :kind="notification.kind"
      :title="notification.title"
      :sub-title="notification.subTitle"
      :caption="notification.caption"
      @close="closeNotification"
    />
  </div>
</template>

<script>
export default {
  props: {
    notification: { type: Object, default: () => {} },
  },
  data() {
    return {
      isVisible: true,
      elementVisible: true,
    };
  },
  created() {
    // After 10 seconds, close notification if it is a success notification
    // Error notifications are present until closed
    setTimeout(() => {
      if (this.notification.kind === "success") this.elementVisible = false;
      // Always run the function for a specific timer length
      this.specificTimerLength();
    }, 10000);
  },
  methods: {
    specificTimerLength() {
      setTimeout(() => {
        // If the notification is info, let it be present for another 5 sec - total 15 sec
        if (this.notification.kind === "info") this.elementVisible = false;
      }, 5000);
    },
    closeNotification() {
      this.isVisible = false;
    },
  },
};
</script>
<style lang="scss">
.bx--toast-notification {
  pointer-events: auto;
}
</style>
